__turbopack_context__.v({
  "hover": "size-and-buy-module__17L5UW__hover",
});
